import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
import { SharedService } from './sharedService';
import { map } from "rxjs/operators";
import { Process } from "../entities/process"
import { environment } from 'src/environments/environment.prod';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  getAttachments(processId: any, stageKey: any) {
    return this.http.get<any>(this.sharedService.apiUrl('process/attachments/')+processId+'/'+stageKey).pipe(
      tap((attachments: any) => this.log(`getting attachments for process ${attachments}`)),
      catchError(this.handleError<any>('getting attachments'))
    );
  }
  getBarChartData(processKey: string, processStage: string, rowKey: string, columnKey: string, niu: string){
    const httpOptionsPDF = {
      params: new HttpParams().set('report', processKey).set('stage', processStage).set('row',rowKey).set('column',columnKey).set('niu', niu)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/barchart'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('getBarchartData'))
    )
    return process$;
  }
  toggleRecursion(elem, status){
    return this.http.get(this.sharedService.apiUrl('process/recursion'), {
      params: new HttpParams()
        .set('rec_num', elem.rec_num)
        .set('last_rec', elem.last_rec)
        .set('status', status)
    }).pipe(
      map(res => {
        return res;
      })
    );
  }
  archiveCompany(tin) {
    return this.http.get(this.sharedService.apiUrl('process') + '/recursionByTin', {
      params: { tin, status: 'REMOVED' }
    });
  }
  getAllAvises(niu: string, cdi: string): Observable<any> {
    let avises$ = this.http.get<any>(this.sharedService.apiUrl('process/avises'),
    {
      params: new HttpParams()
        .set('username', niu).set('cdi',cdi)
    });
    return avises$;
  }
  getAvis(username: string, id: string): Observable<any> {
    let avises$ = this.http.get<any>(this.sharedService.apiUrl('process/total-fee'),
    {
      params: new HttpParams()
        .set('id', id).set('username', username)
    });
    return avises$;
  }
  getLastDsf(niu: string): Observable<Process> {
    let process$ = this.http.get<Process>(this.sharedService.apiUrl('process/lastSubmitted'),
    {
      
      params: new HttpParams()
        .set('username', niu)
    });
    return process$;
  }

  constructor(private http: HttpClient, private sharedService: SharedService) { }
 
  getProcessMapping(processKey: string): Observable<Process> {
    let process$ = this.http.get<Process>(this.sharedService.apiUrl('process/mapping/') + processKey)
    return process$;
  }
  
  getProcessingStages(process: any): Observable<any> {
    return this.http.get<any>(this.sharedService.apiUrl('process/processing-stages/')+process, httpOptions).pipe(
      tap((process: any) => this.log(`processsing stages w/ id=${process}`)),
      catchError(this.handleError<any>('processsing stages'))
    );
  }

  deleteDeclaration(id: any): Observable<any> {
    return this.http.delete<any>(this.sharedService.apiUrl('process/deleteDeclaration/' + id), {}).pipe(
      tap((resource: any) => this.log(`resource deleted`)),
      catchError(this.handleError<any>('deleted'))
    );
}

  getSummary(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('process/summary'), {
      params: new HttpParams()
        .set('year', year)
    }).pipe(
      map(res => {
        return res;
      })
    );
  }

  downloadPDF(report: any, processId: any): Observable<Blob> {

    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/pdf', 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('report', report).set('id', processId).set('lang',localStorage.getItem('lang'))
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/pdf'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download pdf'))
    )
    return process$;

  }

  downloadExcel(report: any, processId: any, year: string): Observable<Blob> {

    const httpOptions = {
      params: new HttpParams().set('report', report).set('id', processId).set('year', year),
      responseType: 'blob' as 'json'
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/excel'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('download docflow file'))
    )
    return process$;
  }

  downloadGeneratedFile(id: any, content = null): Observable<any> {
    const lang = localStorage.getItem("default_lang") || environment.default_lang || "fr";
  
    let params = new HttpParams().set("id", id).set("lang", lang);
    if (content !== null) {
      params = params.set("content", content);
    }
  
    const httpOptions = { params };
  
    let process$ = this.http
      .get<any>(this.sharedService.apiUrl("process/receiptFile"), httpOptions)
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(this.handleError<any>("submission data"))
      );
  
    return process$;
  }

  downloadReceiptPdf(ref_num: string, headers: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({
        'Accept': 'application/pdf',
        'Content-Type': 'application/json'
      }),
      responseType: 'blob' as 'json',
      params: new HttpParams()
        .set('reference_number', ref_num)
        .set('headers', JSON.stringify(headers)),
    };
  
    return this.http
      .get<any>(this.sharedService.apiUrl('fees/pdf'), httpOptionsPDF)
      .pipe(
        map((res: any) => res),
        catchError(this.handleError<any>('download pdf'))
      );
  }

  getAvisData(id: any, content = null): Observable<any> {
    const lang = localStorage.getItem("default_lang") || environment.default_lang || "fr";
  
    let params = new HttpParams().set("id", id).set("lang", lang);
    if (content !== null) {
      params = params.set("content", content);
    }
  
    const httpOptions = { params };
  
    let process$ = this.http
      .get<any>(this.sharedService.apiUrl("process/avisData"), httpOptions)
      .pipe(
        map((res: Response) => {
          return res;
        }),
        catchError(this.handleError<any>("avis data"))
      );
  
    return process$;
  }

  getDeclarationTemplateData(id: any): Observable<any> {
    const lang = localStorage.getItem("default_lang") || environment.default_lang || "fr";
    const params = new HttpParams().set("id", id).set("lang", lang);
    return this.http
      .get<any>(this.sharedService.apiUrl("process/declarationTemplateData"), { params })
      .pipe(
        map((res: Response) => res),
        catchError(this.handleError<any>("declaration template data"))
      );
  }

  downloadUploadFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('file', name)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/file'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  downloadMappingFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('file', name)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/mapping'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  downloadFileFromDocflow (name: any): Observable<Blob> {

    const httpOptions = {
      params: new HttpParams().set('name', name),
      responseType: 'blob' as 'json'
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/docflowfile'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('download docflow file'))
    )
    return process$;

  }

  
  

  downloadEditingPDF(stage: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/pdf', 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json'    
    };
    let process$ = this.http.post<any>(this.sharedService.apiUrl('process/pdfediting'), {stage:stage}, httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download pdfediting'))
    )
    return process$;

  }

  downloadList(filterObject: any, extraData: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams().set('object', JSON.stringify(filterObject)).set('extraData', JSON.stringify(extraData)),
      responseType: 'blob' as 'json'
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/download-list'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('download docflow file'))
    )
    return process$;
  }

  downloadActivityList(objectFilter: any, headers: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams()
        .set('object', (JSON.stringify(objectFilter))) 
        .set('headers', (JSON.stringify(headers))),    
      responseType: 'blob' as 'json'
    };
  
    return this.http.get<Blob>(this.sharedService.apiUrl('process/download-activity-list'), httpOptions)
      .pipe(
        catchError(this.handleError<Blob>('download statistics activity'))
      );
  }

  downloadUserDecActivityList(objectFilter: any, headers: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams()
        .set('object', JSON.stringify(objectFilter))
        .set('headers', JSON.stringify(headers)),
      responseType: 'blob' as 'json'
    };
  
    return this.http.get<Blob>(
      this.sharedService.apiUrl('process/download-user-dec-activity'),
      httpOptions
    ).pipe(
      catchError(this.handleError<Blob>('download user dec activity'))
    );
  }

  getProcessCountByRecNum(recNum: number): Observable<{ count: number }> {
    const url = this.sharedService.apiUrl(`process/count-by-recnum/${recNum}`);
    return this.http.get<{ count: number }>(url);
  }
  
  getProcesses(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10, filterObject): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process'), {
      
      params: new HttpParams()
        .set('year', year)
        .set('filter', filter)
        .set('object', JSON.stringify(filterObject))
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }).pipe(
      map(res => {
        res['payload'] = res;
        return res["payload"];
      })
    );
  }
 
  getRecurringProcesses(filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process/recurring'), {
      
      params: new HttpParams()
        .set('filter', filter)
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }).pipe(
      map(res => {
        res['payload'] = res;
        return res["payload"];
      })
    );
  }

  getTaxPayersFromProcessSummary(year: string,
    filter = '', sortOrder = 'asc', sortColumn = '',
    pageNumber = 0, pageSize = 10, filterObject:any): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process/taxpayerSummary'), {
      
      params: new HttpParams()
        .set('year', year)
        .set('filter', filter)
        .set('filter.object',JSON.stringify(filterObject))
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
    }).pipe(
      map(res => {
        res['payload'] = res;
        return res["payload"];
      })
    );
  }

  getExcelReport(year, service, page): Observable<Blob> {

    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('year', year).set('key', service).set('page', page)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('process/page_excel'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download excel'))
    )
    return process$;

  }

  deleteFile (name: any): Observable<Blob> {

    const httpOptions = {
      params: new HttpParams().set('filename', name)
    };
    let process$ = this.http.delete<any>(this.sharedService.apiUrl('process/docflowfile'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('delete docflow file'))
    )
    return process$;

  }

  deleteAttachment (prc: any): Observable<Blob> {
    const httpOptions = {
      params: new HttpParams().set('p_id', prc.p_id).set('p_stage', prc.p_stage).set('p_row', prc.p_row)
    };
    let process$ = this.http.delete<any>(this.sharedService.apiUrl('process/attachment'), httpOptions).pipe(
      map((res: Response) => { return res}), catchError(this.handleError<any>('delete process attachement'))
    )
    return process$;

  }

  getProcess(id: string): Observable<Process> {
    let process$ = this.http.get<Process>(this.sharedService.apiUrl('process/') + id)
    return process$;
  }

  getActivityList(
    sortOrder = 'asc',
    sortColumn = '',
    pageNumber = 0,
    pageSize = 10,
    filterObject: any
): Observable<Process[]> {
    return this.http.get(this.sharedService.apiUrl('process/activity-list'), {
        params: new HttpParams()
            .set('sortOrder', sortOrder)
            .set('sortColumn', sortColumn.toString())
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString())
            .set('object', JSON.stringify(filterObject))
    }).pipe(
        map(res => res),
        catchError(this.handleError<any>('getActivityList'))
    );
}

getSubmittedDecList(
  sortOrder = 'asc',
  sortColumn = '',
  pageNumber = 0,
  pageSize = 10,
  filterObject: any
): Observable<any> {
  return this.http.get(
    this.sharedService.apiUrl('process/submitted-dec-list'),
    {
      params: new HttpParams()
        .set('sortOrder', sortOrder)
        .set('sortColumn', sortColumn.toString())
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
        .set('object', JSON.stringify(filterObject))
    }
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('getSubmittedDecList'))
  );
}

getUserDecActivityList(
  sortOrder = 'asc',
  sortColumn = '',
  pageNumber = 0,
  pageSize = 10,
  filterObject: any
): Observable<Process[]> {
  return this.http.get(this.sharedService.apiUrl('process/user-dec-activity'), {
      params: new HttpParams()
          .set('sortOrder', sortOrder)
          .set('sortColumn', sortColumn.toString())
          .set('pageNumber', pageNumber.toString())
          .set('pageSize', pageSize.toString())
          .set('object', JSON.stringify(filterObject))
  }).pipe(
      map(res => res),
      catchError(this.handleError<any>('getUserDecActivityList'))
  );
}

prepareAvisBulk(filterObject: any): Observable<any> {
  return this.http.post(
    this.sharedService.apiUrl('process/avis-bulk/prepare'),
    filterObject
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('prepareAvisBulk'))
  );
}

getAvisBulkStatus(jobId: string): Observable<any> {
  return this.http.get(
    this.sharedService.apiUrl('process/avis-bulk/status/' + jobId)
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('getAvisBulkStatus'))
  );
}

deleteAvisBulk(jobId: string): Observable<any> {
  return this.http.delete(
    this.sharedService.apiUrl('process/avis-bulk/' + jobId)
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('deleteAvisBulk'))
  );
}

downloadAvisBulkFile(jobId: string, fileIndex: number): Observable<any> {
  return this.http.get(
    this.sharedService.apiUrl('process/avis-bulk/download/' + jobId + '/' + fileIndex),
    { responseType: 'blob' }
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('downloadAvisBulkFile'))
  );
}

getCurrentAvisBulkJob(): Observable<any> {
  return this.http.get(
    this.sharedService.apiUrl('process/avis-bulk/current')
  ).pipe(
    map(res => res),
    catchError(this.handleError<any>('getCurrentAvisBulkJob'))
  );
}

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    //this.messageService.add('HeroService: ' + message);
  }
}
